import { React, useState, useEffect } from 'react';
import {
  SidebarContainer,
  SidebarExpandedContainer,
  SidebarCollapsedContainer,
} from '@atoms/sidebar/sidebar.styles';
import {
  Recoil_Quarter_State,
  Year_Wise_Data_State,
  Current_User,
  System_Date_Time_State,
  SidebarExpandCollapseState,
} from '@recoil/recoil';
import { useRecoilState, useRecoilValue } from 'recoil';
import { pastSidebarPL } from '@services/pursuitLeaderServices';
import SpinnerLoader from '@atoms/SpinnerLoader';
import QuarterlyPastCollapsedSidebar from '@molecules/pursuitLeader/components/quarterlyPastCollapsedSidebar';
import QuarterlyPastExpandedSidebar from '@molecules/pursuitLeader/components/quarterlyPastExpandedSidebar';
import { logError } from '@util/commonFunctions';

const PlPastQuarterlySidebar = props => {
  const [expandedQuarter, setExpandedQuarter] = useState('');
  const [yearQuaterWiseData, setYearQuaterWiseData] = useRecoilState(Year_Wise_Data_State);
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const sidebarExpandState = useRecoilValue(SidebarExpandCollapseState);
  const [isLoading, setIsLoading] = useState(true);

  let currentYear;
  const quarter = props.data.quarter;

  setTimeout(() => {
    if (quarterData !== null && expandedQuarter === '') {
      const expandThisQuarter = quarterData.quarter;
      setExpandedQuarter(expandThisQuarter);
    }
  }, 1000);

  if (quarterData !== null) {
    currentYear = quarterData.fiscal_year;
  }

  const EMAIL = currentUser.email;
  const YEAR = currentYear;
  const QUARTER = quarter;
  const DATE = systemDateTime;

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (quarterData !== null) {
          const data = await pastSidebarPL(EMAIL, YEAR, QUARTER, DATE);
          setYearQuaterWiseData(data);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        logError('pastSidebarPL', error);
      }
    };

    fetchData();
  }, [currentUser.email, currentYear, quarter, quarterData, systemDateTime]);
  const toggleAccordion = quarter => {
    if (expandedQuarter === quarter) {
      setExpandedQuarter(null);
    } else {
      setExpandedQuarter(quarter);
    }
  };

  return (
    <>
      {isLoading ? (
        <div style={{ position: 'relative', top: '50%', left: '50%' }}>
          <SpinnerLoader color="#ffffff" />
        </div>
      ) : (
        <SidebarContainer>
          {!!yearQuaterWiseData && !sidebarExpandState ? (
            <SidebarCollapsedContainer>
              {Object.entries(yearQuaterWiseData).map(([key, item]) => (
                <QuarterlyPastCollapsedSidebar
                  key={key}
                  data={item}
                  quarter={key}
                  quarterTitle={item?.title_name}
                  propsData={props.data}
                />
              ))}
            </SidebarCollapsedContainer>
          ) : (
            <SidebarExpandedContainer style={{ paddingTop: '20px' }}>
              {Object.entries(yearQuaterWiseData).map(([key, item]) => (
                <QuarterlyPastExpandedSidebar
                  key={key}
                  data={item}
                  quarter={key}
                  propsData={props.data}
                  year={item?.year}
                  expanded="expanded"
                  toggleAccordion={() => toggleAccordion('Q1')}
                />
              ))}
            </SidebarExpandedContainer>
          )}
        </SidebarContainer>
      )}
    </>
  );
};

export default PlPastQuarterlySidebar;
